import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatInputModule } from '@angular/material/input'
import { MatFormField } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider'
import { MatChipsModule } from '@angular/material/chips'
import { AsyncPipe, DatePipe, LowerCasePipe, TitleCasePipe } from '@angular/common';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, switchMap, take } from 'rxjs';
import { AgePipe } from '../age.pipe';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PatientDetailsKeyService } from '../patient-sidedetails/patient-details-key.service';
import { EncounterServiceService } from '../patient-wrapper/encounter-service.service';
import { AuthService } from '../shared/auth/auth.service';
import { StateService } from '../shared/state.service';
import { ErrorService } from '../shared/error.service';
import { CodeableConcept2Pipe } from "../shared/codeable-concept2.pipe";
import { NaPipe } from "../shared/na.pipe";
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';
import { ChipsDirective } from '../chips.directive';
import { EmptyStateComponent } from '../shared/empty-state/empty-state.component';
import { DetailsBuilderObject } from '../detailz-viewz/details-builder.service';
import { DetailzViewzComponent } from '../detailz-viewz/detailz-viewz.component';
import { MatDialog } from '@angular/material/dialog';
import { DynamicFormsV2Component } from '../shared/dynamic-forms-v2/dynamic-forms-v2.component';
import { FormFieldsSelectDataService } from '../shared/form-fields-select-data.service';
import { FormFields, formMetaData, GroupField, IndividualField, SingleCodeField } from '../shared/dynamic-forms.interface2';
import { backendEndPointToken } from '../app.config';
import { EmphasisDirective } from '../shared/directives/emphasis.directive';



// condition: {
//   keyProperties: [
//     "clinicalStatus",
//     "verificationStatus",
//     "category",
//     "severity",
//     "code",
//     "subject",
//     "encounter",
//     "onsetDateTime",       // or onset[x]
//     "abatementDateTime",   // or abatement[x]
//     "recordedDate",
//     "asserter",
//     "note"
//   ],
//     generalName: "Diagnoses"
// },
@Component({
  selector: 'app-patient-condition',
  imports: [MatCardModule, MatButtonModule, EmptyStateComponent,
    MatFormField, MatDividerModule, DatePipe, RouterLink, ChipsDirective,
    RouterLinkActive, ReferenceDisplayDirective,
    MatExpansionModule, MatCheckboxModule, TitleCasePipe,
    MatTableModule, AsyncPipe,
    MatChipsModule, TableHeaderComponent, EmphasisDirective,
    MatInputModule, LowerCasePipe,
    MatMenuModule, AgePipe, TableHeaderComponent,
    MatTableModule, MatIconModule, ReactiveFormsModule, CodeableConcept2Pipe, NaPipe],
  templateUrl: './patient-condition.component.html',
  styleUrl: './patient-condition.component.scss'
})
export class PatientConditionComponent {
  route = inject(ActivatedRoute);
  patientConditionData: any;
  tableDataSource = new MatTableDataSource();
  tableDataLevel2: BehaviorSubject<any> = new BehaviorSubject([])
  references: Map<string, any> = new Map();

  patientObservationTableFilter: Map<string, any[]> = new Map([[
    'clinicalStatus', ['active', 'recurrence', 'inactive', 'remission', 'resolved']
  ], [
    'verificationStatus', ['unconfirmed', 'provisional', 'differential', 'confirmed', 'refuted', 'entered-in-error']
  ], 
  // [
  //   'category', ['problem-list-item', 'encounter-diagnosis', 'health-concern', 'adverse-event', 'comorbidity', 'diagnosis']
  // ],
   [
    'severity', ['mild', 'moderate', 'severe',]
  ],
  //  [
  //   'name', ['diabetes', 'hypertension', 'asthma', 'cancer', 'heart-disease', 'stroke', 'arthritis', 'depression', 'anxiety', 'obesity']
  // ],
])

  patientObservationTableFilterArray = this.patientObservationTableFilter;
  patientObservationFiltersFormControlObject: any = {};
  patientName!: Observable<string>;
  patientId!: string;
  patientConditionDisplayedColumns = ['recordedDate', 'code', 'verificationStatus', 'clinicalStatus',
    // 'severity',
    'asserter',
    'action'
  ];
  authService = inject(AuthService);
  http = inject(HttpClient);
  private backend = inject(backendEndPointToken);
  private formFieldsDataService = inject(FormFieldsSelectDataService);
  patientOpenAndClose = inject(PatientDetailsKeyService);
  encounterService = inject(EncounterServiceService);
  private dialog = inject(MatDialog);
  conditionDetailsBuilder: DetailsBuilderObject = {
    resourceName: 'Condition',
    resourceLabel: 'Diagnosis Details',
    resourceIcon: 'healing',
    specialHeader: {
      strongSectionKey: 'code',
      iconSectionKeys: ['clinicalStatus', 'verificationStatus'],
      contentSectionKeys: ['subject', 'recordedDate']
    },
    groups: [
      { groupName: 'Classification', groupIcon: 'category', groupKeys: ['clinicalStatus', 'verificationStatus', 'category', 'severity'] },
      { groupName: 'Timeline', groupIcon: 'schedule', groupKeys: ['onsetDateTime', 'abatementDateTime', 'recordedDate'] },
      { groupName: 'People', groupIcon: 'group', groupKeys: ['subject', 'asserter', 'encounter'] },
      { groupName: 'Notes', groupIcon: 'notes', groupKeys: ['note'] }
    ]
  };
  constructor(private router: Router) {
  }
  canAddDiagnosis = this.authService.user.pipe(map(user => {
    return this.authService.can('condition', 'add');
  }));
  canExportDiagnosis = this.authService.user.pipe(map(user => {
    return this.authService.can('condition', 'viewAll');
  }));


  ngOnInit() {
    this.patientId = this.route.parent?.snapshot.params['id'] || '';
    console.log(this.patientId);

    this.tableDataSource.connect = () => {
      return this.tableDataLevel2;
    }

    for (const [key, value] of this.patientObservationTableFilter) {
      this.patientObservationFiltersFormControlObject[key] = new FormGroup({});
      for (const filterValue of value) {
        this.patientObservationFiltersFormControlObject[key].addControl(filterValue, new FormControl(false));
      }
    }

    // this.route.data.subscribe((allData) => {
    this.patientConditionData = this.stateService.PatientResources.condition.subscribe({
      next:
        (data: any) => {
          this.tableDataLevel2.next(data.map((condWrapper: any) => {
            return condWrapper.actualResource
          }).filter((cond: any) => {
            const asserterRef = (cond?.asserter?.reference || '').toString();
            const asserterOk = !asserterRef || asserterRef.startsWith('Practitioner/');

            const verificationCode = cond?.verificationStatus?.coding?.[0]?.code;
            const verificationText = cond?.verificationStatus?.text;
            const isProvisional = (verificationCode === 'provisional') || (verificationText === 'provisional');

            // return asserterOk && !isProvisional;
            return true;
          }));
// $#$          // /* alert(JSON.stringify(this.tableDataLevel2.value) */);

        }

      ,
      error: (err) => {
        console.log(err);
        this.errorService.openandCloseError("Failed to load patient condition data");
      }

    }
    );

    // allData['patCond']['observations'];
    // this.references = new Map(allData['patCond']['references']);
    // console.log(this.references);
    // console.log(this.patientConditionData);


    // });
  }
  stateService = inject(StateService);
  errorService = inject(ErrorService);

  showRow(row: any) {
    this.showDetails(row);
  }

  showDetails(condition: any) {
    const detailsRef = this.dialog.open(DetailzViewzComponent, {
      maxHeight: '93vh',
      maxWidth: '90vh',
      data: {
        resourceData: condition,
        detailsBuilderObject: this.conditionDetailsBuilder,
        actionButtons: [
          {
            key: 'changeConditionStatuses',
            label: 'Change Status',
            icon: 'published_with_changes',
            color: 'primary',
            capabilities: [{ resource: 'condition', action: 'update' }]
          }
        ]
      }
    });

    detailsRef.componentInstance.actionInvoked.pipe(take(1)).subscribe(({ key, resource }) => {
      if (key !== 'changeConditionStatuses') return;
      const cond: any = resource || condition;
      this.openChangeConditionStatusesDialog(cond, detailsRef);
    });
  }

  private openChangeConditionStatusesDialog(condition: any, detailsDialogRef: any): void {
    const conditionId = (condition?.id ?? '').toString().trim();
    if (!conditionId) {
      this.errorService.openandCloseError('Cannot change status: Condition has no id.');
      return;
    }

    if (!this.authService.can('condition', 'update')) {
      this.errorService.openandCloseError('You do not have permission to edit diagnoses.');
      return;
    }

    const currentClinical = (condition?.clinicalStatus?.coding?.[0]?.code ?? condition?.clinicalStatus?.text ?? '').toString().trim().toLowerCase();
    const currentVerification = (condition?.verificationStatus?.coding?.[0]?.code ?? condition?.verificationStatus?.text ?? '').toString().trim().toLowerCase();

    const clinicalOptions$ = this.formFieldsDataService.getFormFieldSelectData('condition', 'clinicalStatus').pipe(
      catchError(() => of([] as any[]))
    );
    const verificationOptions$ = this.formFieldsDataService.getFormFieldSelectData('condition', 'verificationStatus').pipe(
      catchError(() => of([] as any[]))
    );

    forkJoin({ clinicalOptions: clinicalOptions$, verificationOptions: verificationOptions$ }).pipe(take(1)).subscribe(({ clinicalOptions, verificationOptions }) => {
      const clinicalCodes = this.toUniqueCodes(clinicalOptions);
      const verificationCodes = this.toUniqueCodes(verificationOptions);

      const fallbackClinical = ['active', 'recurrence', 'inactive', 'remission', 'resolved'];
      const fallbackVerification = ['unconfirmed', 'provisional', 'differential', 'confirmed', 'refuted', 'entered-in-error'];

      const clinicalList = clinicalCodes.length ? clinicalCodes : fallbackClinical;
      const verificationList = verificationCodes.length ? verificationCodes : fallbackVerification;

      const dynF = this.dialog.open(DynamicFormsV2Component, {
        width: '520px',
        data: {
          formMetaData: <formMetaData>{
            formName: 'Change Diagnosis Status',
            closeDialogOnSubmit: true,
            formDescription: 'Update clinical and verification status. If clinical status becomes resolved, abatement date/time is required.',
            submitText: 'Update'
          },
          formFields: <FormFields[]>[
            <GroupField>{
              generalProperties: <any>{
                fieldApiName: 'statusGroup',
                fieldName: 'Status',
                fieldLabel: 'Status',
                fieldType: 'IndividualField',
                isArray: false,
                isGroup: true
              },
              keys: ['clinicalStatus', 'verificationStatus', 'abatementDateTime'],
              groupFields: {
                clinicalStatus: <SingleCodeField>{
                  generalProperties: <any>{
                    fieldApiName: 'clinicalStatus',
                    fieldLabel: 'Clinical Status',
                    fieldName: 'Clinical Status',
                    fieldType: 'SingleCodeField',
                    inputType: 'select',
                    isArray: false,
                    isGroup: false,
                    value: currentClinical || (clinicalList[0] ?? ''),
                    validations: [{ type: 'default', isFunction: false, name: 'required' }],
                    controllingField: [
                      {
                        isAControlField: true,
                        dependentFieldVisibilityTriggerValue: 'resolved',
                        controlledFieldDependencyId: 'abatementDateTime'
                      }
                    ]
                  },
                  data: clinicalList,
                  dataType: 'string'
                },
                verificationStatus: <SingleCodeField>{
                  generalProperties: <any>{
                    fieldApiName: 'verificationStatus',
                    fieldLabel: 'Verification Status',
                    fieldName: 'Verification Status',
                    fieldType: 'SingleCodeField',
                    inputType: 'select',
                    isArray: false,
                    isGroup: false,
                    value: currentVerification || (verificationList[0] ?? ''),
                    validations: [{ type: 'default', isFunction: false, name: 'required' }]
                  },
                  data: verificationList,
                  dataType: 'string'
                },
                abatementDateTime: <IndividualField>{
                  generalProperties: <any>{
                    fieldApiName: 'abatementDateTime',
                    fieldLabel: 'Abatement Date/Time',
                    fieldName: 'Abatement Date/Time',
                    fieldType: 'IndividualField',
                    inputType: 'datetime-local',
                    isArray: false,
                    isGroup: false,
                    value: '',
                    dependence_id: 'abatementDateTime'
                  },
                  data: null,
                  dataType: 'string'
                }
              }
            }
          ]
        }
      });

      dynF.afterClosed().pipe(
        take(1),
        switchMap((formResult) => {
          const valuesRoot = (formResult?.values ?? {}) as any;
          const values = (valuesRoot?.statusGroup ?? valuesRoot) as any;
          const nextClinical = (values?.clinicalStatus ?? '').toString().trim().toLowerCase();
          const nextVerification = (values?.verificationStatus ?? '').toString().trim().toLowerCase();
          const abatementRaw = (values?.abatementDateTime ?? '').toString().trim();
          if (!nextClinical || !nextVerification) return of(null);

          if (nextClinical === 'resolved' && !abatementRaw) {
            this.errorService.openandCloseError('Abatement Date/Time is required when clinical status is resolved.');
            return of(null);
          }

          const abatementIso = abatementRaw ? new Date(abatementRaw).toISOString() : undefined;

          const updated = {
            ...(condition as any),
            clinicalStatus: this.buildConditionClinicalStatus(nextClinical, clinicalOptions),
            verificationStatus: this.buildConditionVerificationStatus(nextVerification, verificationOptions),
            ...(nextClinical === 'resolved' ? { abatementDateTime: abatementIso } : {})
          };

          return this.http.put<any>(`${this.backend}/Condition/${conditionId}`, updated, {
            headers: new HttpHeaders({
              'Content-Type': 'application/fhir+json',
              'Prefer': 'return=representation'
            })
          }).pipe(
            catchError((e) => {
              console.error('Failed to update Condition', conditionId, e);
              this.errorService.openandCloseError('Failed to update diagnosis status.');
              return of(null);
            })
          );
        })
      ).subscribe((saved) => {
        if (!saved) return;

        // Ensure state updates and details dialog reflects latest representation
        this.stateService.persistPatientResource(saved as any, 'saved');
        if (detailsDialogRef?.componentInstance) {
          detailsDialogRef.componentInstance.resourceData = saved as any;
          if (typeof detailsDialogRef.componentInstance.refresh === 'function') {
            detailsDialogRef.componentInstance.refresh();
          }
        }
      });
    });
  }

  private toUniqueCodes(rawOptions: any): string[] {
    const list: any[] = Array.isArray(rawOptions) ? rawOptions : [];
    const codes = list.map((opt) => {
      if (!opt) return '';
      if (typeof opt === 'string') {
        if (opt.includes('$#$')) return (opt.split('$#$')[0] ?? '').toString().trim().toLowerCase();
        return opt.toString().trim().toLowerCase();
      }
      if (typeof opt === 'object' && typeof opt.code === 'string') {
        return opt.code.trim().toLowerCase();
      }
      if (typeof opt === 'object' && typeof opt.coding?.[0]?.code === 'string') {
        return opt.coding[0].code.trim().toLowerCase();
      }
      return '';
    }).filter(Boolean);
    return Array.from(new Set(codes));
  }

  private buildConditionClinicalStatus(code: string, rawOptions: any): any {
    const coding = this.findCodingForCode(code, rawOptions) || {
      system: 'http://terminology.hl7.org/CodeSystem/condition-clinical',
      code,
      display: code
    };
    return {
      coding: [coding],
      text: coding.display || coding.code
    };
  }

  private buildConditionVerificationStatus(code: string, rawOptions: any): any {
    const coding = this.findCodingForCode(code, rawOptions) || {
      system: 'http://terminology.hl7.org/CodeSystem/condition-ver-status',
      code,
      display: code
    };
    return {
      coding: [coding],
      text: coding.display || coding.code
    };
  }

  private findCodingForCode(code: string, rawOptions: any): { system: string; code: string; display: string } | null {
    const list: any[] = Array.isArray(rawOptions) ? rawOptions : [];
    for (const opt of list) {
      if (!opt) continue;
      if (typeof opt === 'string' && opt.includes('$#$')) {
        const [c = '', display = '', system = ''] = opt.split('$#$');
        if ((c ?? '').toString().trim().toLowerCase() === code.toLowerCase()) {
          return { code: c, display: display || c, system: system || this.backend };
        }
      }
      if (typeof opt === 'object' && typeof opt.code === 'string') {
        const c = opt.code;
        if (c.trim().toLowerCase() === code.toLowerCase()) {
          return { code: c, display: opt.display || c, system: opt.system || this.backend };
        }
      }
    }
    return null;
  }
}
